import { Box, Grid, Stack, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const PASSCODE_PATTERN = /^\d{6}$/;

export default function PassCodeSettings({ rawData }) {
  const settings =
    rawData && typeof rawData === "object" && !Array.isArray(rawData)
      ? rawData
      : { enabled: false, passcode: "" };
  const enabled = settings.enabled === true;
  const hasPasscode = PASSCODE_PATTERN.test(settings.passcode || "");

  return (
    <Stack spacing={1} sx={{ p: 0, flex: 1, justifyContent: "center" }}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                mb: 0.5,
              }}
            >
              <LockOutlinedIcon
                sx={{
                  fontSize: "1rem",
                  color: enabled ? "success.main" : "text.disabled",
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  fontSize: "0.7rem",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                }}
              >
                Status
              </Typography>
            </Box>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                color: enabled ? "success.dark" : "text.secondary",
                fontSize: "0.8rem",
                textTransform: "uppercase",
              }}
            >
              {enabled ? "Enabled" : "Disabled"}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                fontSize: "0.7rem",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: 0.5,
                mb: 0.5,
              }}
            >
              Passcode
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                color: "text.primary",
                fontSize: "0.8rem",
              }}
            >
              {hasPasscode ? settings.passcode : "Not set"}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Typography
        variant="caption"
        sx={{
          mt: 1.5,
          px: 2,
          textAlign: "center",
          color: "text.secondary",
          display: "block",
          lineHeight: 1.4,
        }}
      >
        When enabled, the app shows a splash passcode screen. Users must enter
        the 6-digit code before they can continue.
      </Typography>
    </Stack>
  );
}
